import { Component } from '@angular/core';

/**
 * @description Cartel + botón flotante + panel lateral para acceder a los
 * instructivos (antes era una barra fija arriba de los dashboards de HSE y
 * Capacitaciones — se movió a "bajo demanda" para no competir en jerarquía
 * visual con los datos del dashboard). Ver plan/plan-28.
 *
 * Toda la lógica de carga/progreso/visor de PDF sigue viviendo en
 * `c-card-instructivo`, sin cambios — este componente solo decide
 * cuándo mostrarlo (dentro del `petrol-drawer`).
 */
@Component({
  selector: 'c-instructivos-panel',
  templateUrl: './instructivos-panel.component.html',
  // `host: { class: 'contents' }` — sin esto, el elemento
  // `<c-instructivos-panel>` (un tag desconocido para el navegador) se
  // renderiza `display: inline` por defecto, y el `col-span-12` del cartel
  // interno no tiene ningún efecto porque ese div deja de ser hijo directo
  // de la grilla del dashboard (`class="grid grid-cols-12"`). `contents`
  // saca al host del árbol de layout, dejando que sus hijos (el cartel, el
  // botón flotante, el panel) se comporten como si fueran hijos directos de
  // ese grid — mismo criterio que ya usa el panel lateral de chevron-ng.
  host: { class: 'contents' },
  standalone: false,
})
export class InstructivosPanelComponent {
  isOpen = false;

  open() {
    this.isOpen = true;
  }

  close() {
    this.isOpen = false;
  }
}
